import classNames from 'classnames';
import { COPY } from '../../assets/copy/copy';
import { RepeatIcon } from '../../assets/svgs';
import styles from './StatusIcon.module.scss';

export type RepeatsProps = {
  repeats?: null | boolean;
};

export function RepeatsIcon(_props: RepeatsProps): JSX.Element {
  return (
    <div
      className={classNames(styles['status-icon-component'], 'repeats-icon')}
    >
      <RepeatIcon />
      {COPY.MISSIONS.REPEATABLE}
    </div>
  );
}
